export enum KahunColorMap {
  Default = "#07172E",
  Primary = "#120078",
  PrimaryMain = "#1976d2",
  PrimaryDim = "#4247C9",

  DefaultLight = "#5B5166",
  Accent = "#F37122",
  DefaultDark = "#333333",
  AccentLight = "#FFCD5D",
  AccentLight2 = "#f6dca1",
  AccentLightScroll = "#F0B83A",
  Secondary = "#00AF91",
  SecondaryLight = "#FE3A6A",
  Red = "#CF3D55",
  SecondaryDark = "#026957",
  Background = "#f5f7ff",
  ActionBackground = "#E1DDE5",
  NewDisabledBackground = "#E0E0E0",
  /***
   * @Deprecated use KahunColorMap.NewDisabledBackground instead
   */
  DisabledBackground = "#DEE5FC",
  InputBorder = "#B89CD7",
  GreyBackground = "#FAFAFA",
  LightGrayBackground = "#F7F7F9",
  Divider = "#E9E9E9",
  Edit = "#989df4",
  White = "#FFF",
  MainBackground = "#F6F1F1",
  BlueReferences = "#060EDF",
  FrequencyLabel = "#979797",
  BlackPatientFacing = "#243443",
  QuestionBackground = "#D0CFE3",
  AnswerSelected = "#8481C0",
  AnswerColor = "#5A52C3",

  Emergency = "var(--emergency)",
  EmergencyLight = "var(--emergency-light)",
  Urgent = "var(--urgent)",
  UrgentLight = "var(--urgent-light)",
  NotUrgent = "var(--not-urgent)",
  NotUrgentLight = "var(--not-urgent-light)",
  PrimaryLight = "var(--primary-light)",
}
